/** Wouter's ~ prefix owns the pathname at the root, outside a market Router. */
export function publicRelatedHref(canonical: string): string {
  const url = new URL(canonical);
  return `~${url.pathname}${url.search}`;
}

export function publicHomeHref(routerBase: string): string {
  return `~${routerBase.replace(/\/+$/, "") || "/"}`;
}

/** Shared publications live outside the country Router. Search stays local. */
export function publicNavigationHref(href: string, appBase = "/"): string {
  if (/^\/apex-score(?:[/?#]|$)/.test(href))
    return `~${appBase.replace(/\/+$/, "")}${href}`;
  if (!/^\/(?:help|guides|cities|company|compare|hire|about|models|professional|promise|how-it-works|why-list|list-a-car|pro-owner|refer-a-host|concierge|terms|privacy|bookaclassicisnowdriveshare|category)(?:[/?#]|$)/.test(href)) return href;
  return `~${appBase.replace(/\/+$/, "")}${href}`;
}
